import viVN from 'antd/lib/locale-provider/vi_VN';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import React from 'react';
import 'moment/locale/vi';
import locale from 'antd/es/date-picker/locale/vi_VN';
import './style.scss';

interface IProps {
    value?: Moment;
    defaultValue?: Moment;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    showTime?: boolean;
    disabledDate?: (value: any) => void;
    height?: number;
    onOk?: (date: Moment) => void;
    format?: string;
    suffixIcon?: boolean;
    picker?: 'date' | 'month' | 'quarter' | 'year' | 'time';
    field?: any;
    onChange?: (value: any) => void;
}

const DatePickerWrap: React.FC<IProps> = ({
    onChange,
    placeholder,
    disabled,
    disabledDate,
    showTime,
    value,
    onOk,
    format,
    suffixIcon = false,
    defaultValue,
    picker = 'date',
    field,
}) => {
    const props = {
        disabled,
        disabledDate,
        showTime,
        placeholder,
        onChange,
        value,
        onOk,
        format,
        defaultValue,
        ...(!suffixIcon && { suffixIcon: null }),
    };

    return (
        <DatePicker
            locale={locale}
            className={`datepicker__wrap`}
            picker={picker}
            {...props}
            {...field}
            disabledDate={disabledDate}
            showTime={showTime}
            value={value && !moment(value).isValid() ? '' : value}
            format={picker === 'month' ? 'MM/YYYY' : 'DD/MM/YYYY'}
            allowClear={false}
            inputReadOnly={
                (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 767
            }
        />
    );
};

export default React.memo(DatePickerWrap);
